import { call, put, takeEvery } from 'redux-saga/effects';
import {
    getDpdPlacesFetchSuccess,
    getDpdPlacesFetchFailure,
    getDpdCountriesFetchSuccess,
    getDpdCountriesFetchFailure,
} from './reducer';
import { DpdCountriesResType, DpdPlacesResType } from 'src/types/dpdPlaces';
import api from '@api';
import { getLang } from '@translate';

const getDpdPlacesFetchRequest = async (country: string) => {
    const res = await api(
        'get',
        `api/secure/shippers/dpd/pickup-points?country=${country.toLowerCase()}`
    );
    return res.data;
};

function* getDpdPlacesFetch(action: { type: string; payload: string }) {
    try {
        const response: DpdPlacesResType = yield call((): any => getDpdPlacesFetchRequest(action.payload));
        yield put(getDpdPlacesFetchSuccess({ data: response, country: action.payload }));
    } catch (error) {
        yield put(getDpdPlacesFetchFailure({ error }));
    }
}

export function* getDpdPlacesFetchWatch() {
    yield takeEvery('dpdPlaces/getDpdPlacesFetch', getDpdPlacesFetch);
}

const getDpdCountriesFetchRequest = async () => {
    const lang = getLang().split('-')[0];
    const res = await api('get', 'api/secure/shippers/dpd/countries');

    // Transform the response to match the expected format
    const countries = res.data.map((country: any) => ({
        id: country.COUNTRY_ID,
        name: lang === 'cs' ? country.NAME_CS : country.NAME_EN,
        iso: country.ISO,
        cod_allowed: country.COD_ALLOWED,
    }));

    return { data: { items: countries } };
};

function* getDpdCountriesFetch() {
    try {
        const response: DpdCountriesResType = yield call((): any => getDpdCountriesFetchRequest());

        yield put(getDpdCountriesFetchSuccess(response));
    } catch (error) {
        yield put(getDpdCountriesFetchFailure({ error }));
    }
}

export function* getDpdCountriesFetchWatch() {
    yield takeEvery('dpdPlaces/getDpdCountriesFetch', getDpdCountriesFetch);
}
